import {cookies} from './cookies'
import {$http} from './http'

class User {
    async isLogin(isSession){
        if(this.id) {
            if(isSession){
                await this.isSessionLogin();
            } else {
                await true;
            }
           
        } else {
            await false;
        }
    }
    async isSessionLogin(){
        await $http.get()
    }
    get id(){
        return cookies.get('id') || ''
    }
}

export const user = new User()